module.exports = __webpack_public_path__ + "static/images/smoothness/ui-bg_flat_75_ffffff_40x100.png";